import get from 'lodash/get';
import { getRequestData, getTTRequestData, failAlert } from '@/utils';
import { qryTTCategoryList, qryEmergencyList, saveTTOrder, qryTTOrderList, qryOrderState, closeOrder, reopenOrder, processOrder, qryChnlMgrList } from '@/pages/TTOrder/services';

export default {
  namespace: 'ttOrder',
  state: {
    categoryList: [],
    subTroubleItems: [],
    emergencyList: [], // 紧急程度
    ttStateList: [],
    total: 0,
    searchTableData: [],
    franchiseList: [],
  },
  effects: {
    // 查询categoryList
    *qryTTCategoryList({ payload }, { call, put }) {
      const { parentServiceTypeId } = payload;
      const response = yield call(qryTTCategoryList, payload);
      const { serviceTypeDtoList } = getRequestData(response);
      if (parentServiceTypeId === '0') {
        yield put({
          type: 'save',
          payload: {
            categoryList: serviceTypeDtoList || [],
          },
        });
      } else {
        yield put({
          type: 'save',
          payload: {
            subTroubleItems: !parentServiceTypeId ? [] : (serviceTypeDtoList || []),
          },
        });
      }
    },
    // 重置sub category的数据源
    *resetSubCategory(_, { put }) {
      yield put({
        type: 'save',
        payload: {
          subTroubleItems: [],
        },
      });
    },
    *qryEmergencyList(_, { call, put }) {
      const response = yield call(qryEmergencyList);
      const { emergencyDtoList } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          emergencyList: emergencyDtoList || [],
        },
      });
    },
    *saveTTOrder({ payload }, { call }) {
      const response = yield call(saveTTOrder, payload);
      return getRequestData(response);
    },
    *qryOrderState(_, { call, put }) {
      const response = yield call(qryOrderState);
      const { ttOrderStateList } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          ttStateList: ttOrderStateList || [],
        },
      });
    },
    *qryTTOrderList({ payload }, { call, put }) {
      if (payload.category) {
        payload.complainTypeId = payload.category;
        delete payload.category;
      }
      if (payload.pageDto) {
        delete payload.pageDto;
      }
      const response = yield call(qryTTOrderList, payload);
      const result = getTTRequestData(response);
      const pageIndex = get(result, 'pageNum') || get(payload, 'pageNum');
      if (pageIndex === 1) { // 只有第一页返回的总数才是真正的总数
        yield put({
          type: 'save',
          payload: {
            total: get(result, 'count') || 0,
          },
        });
      }
      yield put({
        type: 'save',
        payload: {
          searchTableData: get(result, 'orderList') || [],
        },
      });
      return result;
    },
    *closeOrder({ payload }, { call }) {
      const response = yield call(closeOrder, payload);
      return getRequestData(response);
    },
    *reopenOrder({ payload }, { call }) {
      const response = yield call(reopenOrder, payload);
      const result = getTTRequestData(response);
      const { resultCode, resultMsg } = result;
      if (resultCode === '0') {
        return true;
      }
      failAlert({
        content: resultMsg,
      });
      return false;
    },
    *processOrder({ payload }, { call }) {
      const response = yield call(processOrder, payload);
      const result = getTTRequestData(response);
      const { resultCode, resultMsg } = result;
      if (resultCode === '0') {
        return true;
      }
      failAlert({
        content: resultMsg,
      });
      return false;
    },
    *qryChnlMgrList({ payload }, { call, put }) {
      const response = yield call(qryChnlMgrList, payload);
      const { data } = response;
      yield put({
        type: 'save',
        payload: {
          franchiseList: data || [],
        },
      });
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
